import {blueGrey} from "material-colors";

// Colors
const primaryColor = "#E2271D";
const lightPrimaryColor = "#f6dbda";
const blueColor = "#4796cb";
const lightBlueColor = "#75aed6";
const greenColor = "#4caf50";
const lightGreenColor = "#74d777";
const successColor = "#4caf50";
const orangeColor = "#ff9800";
const activeColor = "#4caf50";
const textColor = "#4c4c4c";

// BoxShadows
const boxShadow = `0 0px 10px 5px ${blueGrey[50]}, 0 0px 5px 1px ${blueGrey[50]}`;

export {
    primaryColor,
    lightPrimaryColor,
    blueColor,
    lightBlueColor,
    greenColor,
    lightGreenColor,
    successColor,
    orangeColor,
    activeColor,
    textColor,
    boxShadow
}